module.exports = __webpack_public_path__ + "img/email-contact.e7331b74.svg";